<template>
   <v-app>
     <Navbar />
    <v-main>
      <router-view />
    </v-main>
   </v-app>
</template>

<script>
import Navbar from '@/components/Navbar.vue'

const urlParams = new URLSearchParams(window.location.search);
const token = urlParams.get('token');

if (token) {
  localStorage.setItem('auth_token', token);

  // Redirigir a la misma página sin token en URL
  window.history.replaceState({}, document.title, window.location.pathname);
}

export default {
  components: { Navbar }
}
</script>

<style>
body {
  font-family: 'Inter Tight', sans-serif;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-height: 100vh;
  max-width: 100%;
  overflow-x: hidden; /* Evita scroll horizontal */
}

router-view {
  flex: 1;
}
</style>
